<div
  class="file-library"
  cdkDropList
  cdkDropListOrientation="mixed"
  (cdkDropListDropped)="handleDrop($event)"
>
  @for (file of bannerSocialFilesStateService.bannerSocialFilesState(); track $index) {
    <div
      class="file-library-card"
      cdkDrag
      cdkDragHandle
    >
      <app-file-card
        class="app-file-card"
        [fileCard]="{
          id: file.id,
          fileParams: file.file,
          fileType: bannerSocialEntityFileType(),
          isEditModeActive: isEditModeActive(),
          shouldCheckImageType: true
        }"
        [imgSize]="{
          width: '100%',
          height: '250px'
        }"
        [isNeedPreview]="true"
        [cardVariant]="'second'"
        (handleDelete)="handleDelete($event, file)"
      />
    </div>
  }
</div>
